<groundworks-modal>
  <groundworks-modal-header
    title="Foreman Availability Configuration"
    (cancelModal)="closeModal()"
  />
  <groundworks-modal-body>
    @if (isLoading()) {
      <groundworks-state-message type="loading" message="Loading foreman configuration..." />
    }
    @if (hasError() && !isLoading()) {
      <groundworks-state-message
        type="error"
        message="Failed to load foreman configuration. Please try again."
        [button]="retryButton"
      />
    }
    @if (!isLoading() && !hasError() && detail(); as d) {
      <div class="foreman-config-header rounded p-3 mb-4 sticky-top">
        <div class="row">
          <div class="col text-center">
            <div class="fw-bold text-primary foreman-config-header-value">{{ d.name }}</div>
            <small class="foreman-config-header-label">{{ d.status }}</small>
          </div>
          <div class="col text-center">
            <div class="fw-bold text-primary foreman-config-header-value">{{ d.homeBranch }}</div>
            <small class="foreman-config-header-label">Home Branch</small>
          </div>
          <div class="col text-center">
            <div class="fw-bold text-primary foreman-config-header-value">
              {{ d.ivpd | currency }}
            </div>
            <small class="foreman-config-header-label">IVPD</small>
          </div>
        </div>
      </div>

      <section class="foreman-settings mb-4">
        <h5 class="fw-semibold text-primary mb-4">Foreman Settings</h5>
        <p class="fw-semibold mb-2">Project Types to be Scheduled</p>
        <ng-select
          [items]="projectTypes"
          [multiple]="true"
          bindLabel="name"
          bindValue="id"
          placeholder="Please select project types"
          [formControl]="projectTypeFormControl"
          [closeOnSelect]="false"
          [clearSearchOnAdd]="true"
          (search)="onProjectTypeSearch($event)"
          (clear)="onProjectTypeSearchClear()"
          (close)="onProjectTypeDropdownClose()"
          (add)="onProjectTypeAdd()"
        >
          @if (!projectTypeSearchTerm()) {
            <ng-template ng-header-tmp>
              <button type="button" class="ng-option w-100 border-0 bg-transparent text-start" (click)="allSelected() ? deselectAll() : selectAll()">
                <input type="checkbox" [checked]="allSelected()" />
                {{ allSelected() ? 'Deselect All' : 'Select All' }}
              </button>
            </ng-template>
          }
          <ng-template ng-option-tmp let-item="item">
            <input type="checkbox" [checked]="projectTypeFormControl.value?.includes(item.id)" />
            {{ item.name }}
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            @for (item of items; track item) {
              <div class="ng-value bg-body-secondary">
                <span class="ng-value-label text-primary">{{ item.name }}</span>
                <button
                  type="button"
                  class="ng-value-icon right border-0 bg-transparent p-0 ms-1 me-1 text-primary"
                  (click)="clear(item)"
                  aria-label="Remove"
                >
                  ×
                </button>
              </div>
            }
          </ng-template>
        </ng-select>
      </section>

      <section class="weekly-availability mb-4">
        <h5 class="fw-semibold text-primary mb-4">Default Weekly Availability</h5>
        @for (day of days; track day.value) {
          <div class="form-check mb-2">
            <input
              type="checkbox"
              class="form-check-input day-checkbox"
              [id]="'day-' + day.value"
              [checked]="availableDays().includes(day.value)"
              (change)="toggleDay(day.value)"
            />
            <label class="form-check-label" [for]="'day-' + day.value">{{ day.label }}</label>
          </div>
        }
      </section>

      <section class="preferred-crew mb-4">
        <h5 class="fw-semibold text-primary mb-4">Preferred Crew</h5>
        <p class="fw-semibold mb-2">Select Crew to Accompany Foreman</p>
        <ng-select
          [items]="preferredCrewOptions()"
          [multiple]="true"
          bindLabel="name"
          placeholder="Please select crew members"
          [closeOnSelect]="false"
          [clearSearchOnAdd]="true"
          [ngModel]="preferredCrewMembers()"
          (ngModelChange)="onPreferredCrewChange($event)"
          (clear)="clearPreferredCrew()"
        >
          <ng-template ng-option-tmp let-item="item">
            <input type="checkbox" [checked]="isPreferredCrewMemberSelected(item.userId)" />
            {{ item.name }}
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items">
            @for (item of items; track item.userId) {
              <div class="ng-value bg-body-secondary">
                <span class="ng-value-label text-primary">{{ item.name }}</span>
                <button
                  type="button"
                  class="ng-value-icon right border-0 bg-transparent p-0 ms-1 me-1 text-primary"
                  (click)="removePreferredCrewMember(item.userId)"
                  aria-label="Remove"
                >
                  ×
                </button>
              </div>
            }
          </ng-template>
        </ng-select>

        <app-crew-bonus-grid
          [foremanUserId]="foremanUserId()"
          [selectedCrewUserIds]="preferredCrewUserIds()"
        />
      </section>

      <app-foreman-travel-lines
        [foremanUserId]="foremanUserId()"
        [availableBranches]="availableBranches()"
      />

      @if (saveError()) {
        <div class="alert alert-danger" role="alert">
          {{ saveErrorMessage() || 'Failed to save changes. Please try again.' }}
        </div>
      }
    }
  </groundworks-modal-body>
  @if (!isLoading() && !hasError() && detail()) {
    <groundworks-modal-footer [actions]="footerActions" />
  }
</groundworks-modal>
